import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_MEMBERSHIP_UI_UPDATE = defineFcm('growth_membership_ui_update')
	.asBoolean()
	.withDefault(false)
	.toConfig();
